import { render } from "./PasswordUpdateForm.vue?vue&type=template&id=6f267650"
import script from "./PasswordUpdateForm.vue?vue&type=script&lang=js"
export * from "./PasswordUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gizmorilla.com/toolbox.gizmorilla.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__